import React from "react";
import Grid from '@mui/material/Grid2';
import { DrawerProps, styled, Drawer, Box, Stack } from "@mui/material";
import { WithGrow } from "@common/components/WithGrow";
import Typography from "@common/components/Typography";
import Button from "@common/components/Button";
import { useTranslation } from "react-i18next";

type OnAdd = { onAdd: () => void; onSave?: undefined };
type OnSave = { onAdd?: undefined; onSave: () => void };
export type OnAddOrSave = OnAdd | OnSave;
type BottomDrawerProps = DrawerProps & {
  title: string;
  disabled?: boolean;
  onClose: () => void;
} & OnAddOrSave;

const isEditDrawer = (v: OnAddOrSave): v is OnSave =>
  (v as OnSave).onSave !== undefined;
const DrawerHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1, 1.5),
}));
const BottomDrawer = (props: BottomDrawerProps) => {
  const isEdit = isEditDrawer(props);
  const {
    title,
    children,
    disabled = false,
    onSave,
    onAdd,
    onClose,
    ...drawerProps
  } = props;
  const onConfirm = isEdit ? props.onSave : props.onAdd;
  const { t } = useTranslation();

  return (
    <Drawer onClose={onClose} {...drawerProps} anchor="bottom">
      <WithGrow
        sx={(theme) => ({ backgroundColor: theme.palette.background.default })}
        direction="column"
        containerSx={{ padding: 1 }}
        fixed={
          <DrawerHeader>
            <Grid
              container
              direction="row"
              wrap="nowrap"
              sx={{ width: '100%', justifyContent: "space-between", }}
            >
              <Typography
                sx={{
                  alignSelf: "center",
                }}
              >
                {title}
              </Typography>
              <Stack
                direction="row"
                sx={{
                  gap: "1rem",
                }}
              >
                <Button
                  color="white"
                  variant="contained"
                  disabled={disabled}
                  onClick={onConfirm}
                >
                  {t(isEdit ? "Save" : "Add")}
                </Button>
                <Button variant="outlined" color="greyed" onClick={onClose}>
                  {t("Cancel")}
                </Button>
              </Stack>
            </Grid>
          </DrawerHeader>
        }
      >
        {children}
      </WithGrow>
    </Drawer>
  );
};

export default BottomDrawer;
